<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">采购备案审批</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <el-form-item label="需求类型">
            <el-radio-group v-model="form.type" class="type-radio-type">
              <el-radio-button label="0">集团需求</el-radio-button>
              <el-radio-button label="1">子公司需求</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <purchase-record ref="apply" :type="1" :userData="userData" :formByFather="form"></purchase-record>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->
              
            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>

      <div class="tip tip-table">
        <p><span class="tip-lable">注：</span>1、本表的备案范围为单项金额在1万元（含）以上、5万元以下的采购项目；   </p>
        <p>2、单项支出在5万元（含）以上的（年度累计支出未超过招标限额的、单笔超5万元）按照相关制度上报相关部门备案；</p>
        <p>3、备案时附上采购相关资料。</p>
      </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitApply()" class="form-btn" type="success">确认提交采购备案审批
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import PurchaseRecord from '@/page/form/purchase/record'
  export default {
    components: {
      ApprovalItem,
      PurchaseRecord,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          // 0: 集团 1：子公司
          type: 0,
          name: '',
          zbfs: '',
          price: '',
          leaderId: '',
          // type:0 部门  type:1 公司
          depId: '',
          purchaseRecordItems: [],
          json: true,

          projectIds: [],
          projectNames: "",
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }

      // 默认选择需求类型
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.depId == 7) {
        this.form.type = "0"
      } else {
        this.form.type = "1"
      }

      this.approvalUsersData = this.approvalUsers['c71_' + this.form.type]
      this.getApplyData()
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          this.setSelectArr(this.applyInfo, 71, this.form.type / 1)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/purchase/record/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo
          this.form = res.vo
          // this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.form.applyId = this.form.flow.applyId
          this.form.json = true

          if (this.form.projectIds) {
            this.form.projectIds = this.form.projectIds.split(",").map(Number)
          } else {
            this.form.projectIds = []
          }

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []
          this.setSelectArr(this.applyInfo, 71, this.form.type / 1)
          this.formLoading = false
        })
      },
      // 提交使用采购申请单
      SubmitApply() {
        this.form = this.$refs.apply.getFromData()
        this.form.projectIds = this.form.projectIds ? this.form.projectIds.join(",") : ''

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/purchase/record/add' : '/purchase/record/edit?applyId=' + this.form
          .applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交采购备案成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改采购备案成功，请耐心等待领导审批")
          }
          this.$router.push('/Purchase/Record/List')
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      'form.type'() {
        this.approvalUsersData = this.approvalUsers['c71_' + this.form.type]
        this.setSelectArr(this.applyInfo, 71, this.form.type / 1)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/purchase/recordApply.vue